import { Button } from '@mantine/core';
import { useQueryClient } from '@tanstack/react-query';
import { Icon, toastNotifications } from '@uag/react-core';
import { TeamType } from '@uag/welcome-shared/src/api/models';
import { useVerifyContractSignature } from '@uag/welcome-shared/src/api/queries/contracts/contracts';
import {
    getGetRequestDetailQueryKey,
    getGetRequestsQueryKey,
} from '@uag/welcome-shared/src/api/queries/requests/requests';
import { useGetMyTeams } from '@uag/welcome-shared/src/api/queries/teams/teams';
import { isAxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

import { useRequestContext } from '../RequestProvider';
import { RequestActionButtonProps } from './types';

export const ActivateCustomerAction = (_: RequestActionButtonProps) => {
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    const { request } = useRequestContext();
    const { data: myTeams } = useGetMyTeams();

    const { mutateAsync: verifySignature, isPending: isVerifyPending } = useVerifyContractSignature();

    const handleApprove = async () => {
        try {
            await verifySignature({ id: request.id, data: { verifyState: 'Accept' } });
            toastNotifications.success({
                title: t('success'),
                message: t('customerActivated'),
            });
        } catch (error) {
            const detail = isAxiosError(error) ? error.response?.data?.detail : undefined;
            toastNotifications.errorDetail(
                {
                    title: t('failed'),
                    message: detail ?? t('customerActivationFailed'),
                },
                error,
            );
        }
        queryClient.invalidateQueries({ queryKey: getGetRequestDetailQueryKey(request.id) });
        queryClient.invalidateQueries({ queryKey: getGetRequestsQueryKey() });
    };

    const isSignatureTeamMember = myTeams?.data.some((myTeam) => myTeam.teamType === TeamType.SignatureVerification);

    return (
        isSignatureTeamMember && (
            <Button loading={isVerifyPending} type="submit" onClick={handleApprove}>
                {t('activateCustomer')}
                <Icon className="ml-base" icon="check" />
            </Button>
        )
    );
};
